import { MultiAutocomplete } from '@common/ui'
import type { ColumnHeader } from './utils'

type VisibleColumnsPickerProps = {
  columnHeaders: readonly ColumnHeader[]
  visibleColumnHeaders: readonly ColumnHeader[]
  onChange: (visibleColumnIds: ReadonlySet<string>) => void
}

const columnLabel = (column: ColumnHeader) =>
  column.label.secondary ? `${column.label.primary} (${column.label.secondary})` : column.label.primary

const VisibleColumnsPicker = ({ columnHeaders, visibleColumnHeaders, onChange }: VisibleColumnsPickerProps) => (
  <div style={{ padding: 'var(--trellis-spacing-xs)', borderBottom: '1px solid var(--trellis-color-outline)' }}>
    <MultiAutocomplete
      size="sm"
      label="Visible columns"
      placeholder="Add column"
      data={columnHeaders.map((column) => ({ value: column.id, label: columnLabel(column) }))}
      value={visibleColumnHeaders.map((column) => column.id)}
      onChange={(ids) => onChange(new Set(ids))}
    />
  </div>
)

export default VisibleColumnsPicker
